let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c7zLV")).then(() => parcelRequire('1WDy5'));